/*
 * Six Years listicle: the bar that sticks to the bottom of a phone screen.
 *
 * It shows up once the hero has scrolled out of view, and disappears again
 * while a block with its own button is in view: the product card halfway down
 * and the offer at the bottom. On desktop it stays hidden altogether. The height of the bar
 * is written to --six-lst-sticky-height so the stylesheet can give the page
 * that much room at the bottom and the bar never covers anything.
 *
 * Everything re-runs on shopify:section:load, so the bar keeps working after a
 * change in the theme editor.
 */
(function () {
  'use strict';

  var DESKTOP = '(min-width: 750px)';
  var state = null;

  function clearState() {
    if (!state) return;
    window.removeEventListener('scroll', state.onScroll);
    window.removeEventListener('resize', state.onResize);
    if (state.observer) state.observer.disconnect();
    document.documentElement.style.removeProperty('--six-lst-sticky-height');
    state = null;
  }

  function setup() {
    clearState();

    var bar = document.querySelector('[data-six-listicle-sticky]');
    if (!bar) return;

    var anchor = document.querySelector('[data-six-listicle-sticky-anchor]');
    // More than one block can push the bar aside: the product card halfway
    // down and the offer at the bottom.
    var stops = document.querySelectorAll('[data-six-listicle-sticky-stop]');

    function onDesktop() {
      return window.matchMedia && window.matchMedia(DESKTOP).matches;
    }

    function measure() {
      if (onDesktop()) {
        document.documentElement.style.removeProperty('--six-lst-sticky-height');
        return;
      }
      document.documentElement.style.setProperty(
        '--six-lst-sticky-height',
        bar.offsetHeight + 'px'
      );
    }

    function update() {
      if (onDesktop()) {
        bar.classList.remove('is-visible');
        return;
      }
      // No hero on the page: show the bar as soon as the visitor scrolls.
      var passed = anchor
        ? anchor.getBoundingClientRect().bottom < 0
        : window.scrollY > 400;

      // Those blocks have their own button. While one is in view the bar
      // steps aside, so there are never two buttons on screen at once.
      var buttonInView = false;
      for (var i = 0; i < stops.length; i++) {
        var box = stops[i].getBoundingClientRect();
        if (box.top < window.innerHeight && box.bottom > 0) {
          buttonInView = true;
          break;
        }
      }

      bar.classList.toggle('is-visible', passed && !buttonInView);
    }

    function onScroll() {
      update();
    }

    function onResize() {
      measure();
      update();
    }

    var observer = null;
    if (window.ResizeObserver) {
      observer = new ResizeObserver(measure);
      observer.observe(bar);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);

    state = { onScroll: onScroll, onResize: onResize, observer: observer };

    measure();
    update();
  }

  // The theme editor re-inserts this script tag when the section reloads, which
  // runs the file a second time. Hook up the listeners once and let every later
  // run only redo the setup, otherwise they pile up.
  if (window.sixListicleStickySetup) {
    window.sixListicleStickySetup();
    return;
  }
  window.sixListicleStickySetup = setup;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('shopify:section:unload', setup);
})();
